import revive_payload_client_4sVQNw7RlN from "/vercel/path0/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/vercel/path0/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/vercel/path0/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/vercel/path0/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/vercel/path0/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/vercel/path0/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/vercel/path0/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/vercel/path0/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_iGLjBbor9q from "/vercel/path0/node_modules/nuxt-jsonld/dist/runtime/plugin.js";
import plugin_42RIGIx6e8 from "/vercel/path0/node_modules/@nuxt/image/dist/runtime/plugin.js";
import plugin_client_xSLIPjreZL from "/vercel/path0/node_modules/nuxt-meta-pixel/dist/runtime/plugin.client.mjs";
import plugin_client_UYiXMU8ZyN from "/vercel/path0/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import plugin_Jozdw60ZsE from "/vercel/path0/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import plugin_ghbUAjaD3n from "/vercel/path0/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import switch_locale_path_ssr_5csfIgkrBP from "/vercel/path0/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/vercel/path0/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import pwa_icons_plugin_LnrhIJeMG7 from "/vercel/path0/.nuxt/pwa-icons-plugin.ts";
import pwa_client_ZuYw5i1i7i from "/vercel/path0/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.js";
import db_mWfD51wL77 from "/vercel/path0/plugins/db.ts";
import router_client_W01CLn04zL from "/vercel/path0/plugins/router.client.ts";
import local_storage_XLntFZXOcQ from "/vercel/path0/plugins/local-storage.ts";
import global_enums_RTa4d5iRDo from "/vercel/path0/plugins/global-enums.ts";
import versions_CDm81L1VC8 from "/vercel/path0/plugins/versions.ts";
import quiz_jnk0QoeAS3 from "/vercel/path0/plugins/quiz.ts";
import uuid_CVylJR1NkO from "/vercel/path0/plugins/uuid.ts";
import window_mY4jZ4wBC5 from "/vercel/path0/plugins/window.ts";
import mixpanel_client_JbuVUz27YJ from "/vercel/path0/plugins/mixpanel.client.ts";
import pwa_install_client_BbLJhCZ7g8 from "/vercel/path0/plugins/pwa-install.client.ts";
import analytics_client_mtqVw3YRXk from "/vercel/path0/plugins/analytics.client.ts";
import sentry_client_shVUlIjFLk from "/vercel/path0/plugins/sentry.client.ts";
import openreplay_xOQvzhrpAg from "/vercel/path0/plugins/openreplay.ts";
import snap_pixel_client_mh6W1T8p8X from "/vercel/path0/plugins/snap-pixel.client.ts";
import twitter_pixel_client_grF0EYHvgj from "/vercel/path0/plugins/twitter-pixel.client.ts";
import tiktok_pixel_client_h0szZnSRSo from "/vercel/path0/plugins/tiktok-pixel.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_iGLjBbor9q,
  plugin_42RIGIx6e8,
  plugin_client_xSLIPjreZL,
  plugin_client_UYiXMU8ZyN,
  plugin_Jozdw60ZsE,
  plugin_ghbUAjaD3n,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  pwa_icons_plugin_LnrhIJeMG7,
  pwa_client_ZuYw5i1i7i,
  db_mWfD51wL77,
  router_client_W01CLn04zL,
  local_storage_XLntFZXOcQ,
  global_enums_RTa4d5iRDo,
  versions_CDm81L1VC8,
  quiz_jnk0QoeAS3,
  uuid_CVylJR1NkO,
  window_mY4jZ4wBC5,
  mixpanel_client_JbuVUz27YJ,
  pwa_install_client_BbLJhCZ7g8,
  analytics_client_mtqVw3YRXk,
  sentry_client_shVUlIjFLk,
  openreplay_xOQvzhrpAg,
  snap_pixel_client_mh6W1T8p8X,
  twitter_pixel_client_grF0EYHvgj,
  tiktok_pixel_client_h0szZnSRSo
]